/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CustomCreateUserMutationVariables = Types.Exact<{
  input: Types.CustomCreateUserInput;
}>;


export type CustomCreateUserMutation = { __typename?: 'Mutation', customCreateUser?: { __typename?: 'Token', authToken: string } | null };


export const CustomCreateUserDocument = gql`
    mutation CustomCreateUser($input: CustomCreateUserInput!) {
  customCreateUser(input: $input) {
    authToken
  }
}
    `;
export type CustomCreateUserMutationFn = Apollo.MutationFunction<CustomCreateUserMutation, CustomCreateUserMutationVariables>;

/**
 * __useCustomCreateUserMutation__
 *
 * To run a mutation, you first call `useCustomCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateUserMutation, { data, loading, error }] = useCustomCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateUserMutation, CustomCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateUserMutation, CustomCreateUserMutationVariables>(CustomCreateUserDocument, options);
      }
export type CustomCreateUserMutationHookResult = ReturnType<typeof useCustomCreateUserMutation>;
export type CustomCreateUserMutationResult = Apollo.MutationResult<CustomCreateUserMutation>;
export type CustomCreateUserMutationOptions = Apollo.BaseMutationOptions<CustomCreateUserMutation, CustomCreateUserMutationVariables>;